import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import OddsHistory from '../oddsHistory/oddsHistory';
import { useMemo } from 'react';
import { BetbleLink, BetbleSite, SiteLogo } from './styled';

const International = ({ item, gameData }) => {
  const [selectedTab, setSelectedTab] = useState('windrawloss');

  return (
    <div className="odds_column">
      <h3 className="tit">배당현황</h3>
      <div className="tab">
        <ul>
          <li>
            <button
              onClick={() => setSelectedTab('windrawloss')}
              className={selectedTab === 'windrawloss' ? 'selected' : ''}
            >
              일반
            </button>
          </li>
          <li>
            <button
              onClick={() => setSelectedTab('handicap')}
              className={selectedTab === 'handicap' ? 'selected' : ''}
            >
              핸디캡
            </button>
          </li>
          <li>
            <button
              onClick={() => setSelectedTab('unover')}
              className={selectedTab === 'unover' ? 'selected' : ''}
            >
              언더오버
            </button>
          </li>
        </ul>
      </div>

      <div className="odds_list foreign_list">
        <div className="hd">
          <span>기준</span>
          <span>{selectedTab === 'unover' ? '언더' : '승'}</span>
          <span>무</span>
          <span>{selectedTab === 'unover' ? '오버' : '패'}</span>
        </div>
        <div className="bd">
          {item.map((odds) => (
            <Odds
              key={odds.siteName}
              data={odds}
              type={selectedTab}
              gameData={gameData}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const siteLogos = {
  bet365: 'BET365',
  '1xBet': 'XBET',
  '10Bet': 'TENBET',
  SBOBET: 'SBOBET',
  Dafabet: 'DAFABET',
  'William Hill': 'WILLIAM',
  BETMAN: 'BETMAN'
};

const Odds = ({ data, type, gameData }) => {
  const { siteName, getOdds } = data;
  const { detail } = gameData;
  const { betbleUri } = detail;
  const { winLoseOdds, handicapOdds, underOverOdds } = getOdds;
  const [historyPopup, toggleHistoryPopup] = useState({
    open: false,
    id: null,
    type: 'win',
    ref: null
  });
  const itemRef = useRef();

  const { win, draw, loss, option } = useMemo(() => {
    if (type === 'windrawloss') {
      return {
        win: winLoseOdds.win,
        draw: winLoseOdds.draw,
        loss: winLoseOdds.loss,
        option: ''
      };
    } else if (type === 'handicap') {
      return {
        win: handicapOdds.win,
        draw: handicapOdds.draw,
        loss: handicapOdds.loss,
        option: handicapOdds.option
      };
    } else {
      return {
        win: underOverOdds.win,
        draw: underOverOdds.draw,
        loss: underOverOdds.loss,
        option: underOverOdds.option
      };
    }
  }, [type]);

  const onClickOddsHistory = () => {
    if (
      win.isChange === null &&
      draw.isChange === null &&
      loss.isChange === null
    ) {
      return;
    } else {
      if (historyPopup.open) {
        onClosePopup();
      } else {
        let id = null;
        let type;

        if (!!win.isChange) {
          id = win.id;
          type = 'win';
        } else if (!!draw.isChange) {
          id = draw.id;
          type = 'draw';
        } else if (!!loss.isChange) {
          id = loss.id;
          type = 'loss';
        }

        toggleHistoryPopup({ open: true, id, type, ref: itemRef });
      }

      return;
    }
  };
  const handleClickBetbleLink = (event) => {
    event.stopPropagation();
    let type = 0;

    if (detail.getTracker.status === 'progress') {
      type = 1;
    }
    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;
    window.open(url);
  };

  const onClosePopup = () => {
    toggleHistoryPopup({ open: false, id: null, type: 'win', ref: null });
  };
  const isBetble = siteName === 'BETBLE';
  const siteLogo = siteLogos[siteName] || null;

  return (
    <div className="item" onClick={() => onClickOddsHistory()} ref={itemRef}>
      <div className="inner">
        <div className={clsx('type')}>
          {siteLogo !== null && <SiteLogo siteLogo={siteLogo} />}
          {siteLogo === null && !isBetble && <>{siteName.toLowerCase()}</>}
          {isBetble && <BetbleSite />}

          {isBetble && betbleUri && (
            <BetbleLink onClick={handleClickBetbleLink}>베팅</BetbleLink>
          )}
        </div>
        <span className={clsx('point', type === 'unover' && 'unover')}>
          {type !== 'windrawloss' && !!option && option}
        </span>
        <span className={clsx(!!win.isChange && win.isChange)}>
          {win.value}
        </span>
        <span className={clsx(!!draw.isChange && draw.isChange)}>
          {draw.value}
        </span>
        <span className={clsx(!!loss.isChange && loss.isChange)}>
          {loss.value}
        </span>
      </div>

      {historyPopup.open && (
        <OddsHistory
          oddsId={historyPopup.id}
          type={historyPopup.type}
          close={onClosePopup}
          parentRef={historyPopup.ref}
          selectedTab={type}
        />
      )}
    </div>
  );
};

export default International;
